export default "/kiban/_next/static/images/red-7c69d30e9db88e0238e9f148d8dd737a.png";